module.exports = __webpack_public_path__ + "static/img/index_09.b375ee3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index_09.png
// module id = /vDo
// module chunks = 1